import
{
  routes
} from '../../options/routes';

const setLocalStorage = data =>
{
  // Set local storage details and redirect to home route
  localStorage.setItem('token', JSON.stringify(data.accessToken));
  localStorage.setItem('userRole', JSON.stringify(data.role));
  localStorage.setItem('userProfile', JSON.stringify(data.user));
  localStorage.setItem('clubProfile', JSON.stringify(data.club));
  localStorage.removeItem("invoice_data");
  const windowUrl = window.location.search;
  const params = new URLSearchParams(windowUrl);
  if (params.has('redirect'))
  {
    window.location.href = params.get('redirect');
  } else if (!data.noredir)
  {
    window.location.href = routes.home;
  }


};

export default setLocalStorage;